import * as React from "react";
import type { SVGProps } from "react";
const SvgConsistentBrand1 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={64}
    height={64}
    fill="none"
    {...props}
  >
    <path
      fill="#D3ECF8"
      d="M1.054 21.456h47.022v14.563H1.054V21.456ZM15.94 1.026h46.633v15.731H15.94V1.027Z"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M1.827 23.206v32.379h45.397v-32.38H1.827Zm-.335-1.75c-.781 0-1.415.633-1.415 1.414v33.05c0 .781.634 1.415 1.415 1.415h46.067c.781 0 1.415-.634 1.415-1.415V22.87c0-.781-.634-1.414-1.415-1.414H1.492Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M14.59 2.44A2.29 2.29 0 0 1 16.88.152h44.753a2.29 2.29 0 0 1 2.29 2.29v59.118a2.29 2.29 0 0 1-2.29 2.29H16.88a2.29 2.29 0 0 1-2.29-2.29v-4.825h1.75v4.825c0 .298.241.54.54.54h44.753a.54.54 0 0 0 .54-.54V2.441a.54.54 0 0 0-.54-.54H16.88a.54.54 0 0 0-.54.54v19.32h-1.75V2.44Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      d="M25.294 41.065a1.18 1.18 0 0 1 1.179-1.18h15.051a1.18 1.18 0 0 1 0 2.359H26.473a1.18 1.18 0 0 1-1.18-1.18ZM25.294 44.838a1.18 1.18 0 0 1 1.179-1.18h15.051a1.18 1.18 0 0 1 0 2.359H26.473a1.18 1.18 0 0 1-1.18-1.18Z"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M7.878 27.02v4.518h9.704V27.02H7.878Zm-.807-1.75a.943.943 0 0 0-.943.944v6.13c0 .521.422.944.943.944H18.39c.521 0 .943-.423.943-.944v-6.13a.943.943 0 0 0-.943-.944H7.071Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      d="M36.813 7.077c0-.669.542-1.21 1.21-1.21h19.709a1.21 1.21 0 0 1 0 2.42H38.024a1.21 1.21 0 0 1-1.21-1.21ZM36.813 11.917c0-.668.542-1.21 1.21-1.21h19.709a1.21 1.21 0 0 1 0 2.42H38.024a1.21 1.21 0 0 1-1.21-1.21Z"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M22.076 7.616v4.517h9.705V7.616h-9.705Zm-.807-1.75a.943.943 0 0 0-.943.944v6.13c0 .521.422.943.943.943h11.318c.521 0 .944-.422.944-.943V6.81a.943.943 0 0 0-.944-.944H21.27Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgConsistentBrand1;
